export const PushNotificationEndpoints = {
  list: '/push-notification/list',
  add: '/push-notification/add',
  details: (id: string) => `/push-notification/${id}`,
  update: (id: string) => `/push-notification/${id}`,
  send: (id: string) => `/push-notification/${id}/send`,
  cancel: (id: string) => `/push-notification/${id}/cancel`,
  consumers: '/push-notification/consumer/list',
};
